import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { motion } from 'framer-motion';

const FrameworkOS = () => {
  const steps = [
    { name: "SAFE AI Framework", icon: FiIcons.FiShield, color: "bg-brand-navy text-white" },
    { name: "AI Discovery Call", icon: FiIcons.FiPhone, color: "bg-brand-teal text-white" },
    { name: "AI Leadership Review", icon: FiIcons.FiActivity, color: "bg-brand-teal text-white" },
    { name: "AI Confidence Training", icon: FiIcons.FiUsers, color: "bg-brand-teal text-white" },
    { name: "AI Leadership Sprint", icon: FiIcons.FiZap, color: "bg-brand-teal text-white" }
  ];

  return (
    <div className="mt-24 max-w-2xl mx-auto">
      <div className="text-center mb-12">
        <h3 className="text-2xl font-bold text-brand-navy mb-4">A consistent leadership approach</h3>
        <p className="text-gray-600 italic">The SAFE AI Framework is the leadership methodology behind every service we offer.</p>
      </div>
      
      <div className="flex flex-col items-center">
        {steps.map((step, i) => (
          <React.Fragment key={i}>
            <motion.div 
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              className={`${step.color} px-8 py-5 rounded-2xl shadow-sm border border-black/5 flex items-center gap-4 w-full md:w-[400px] justify-center font-bold text-sm tracking-tight`}
            >
              <SafeIcon icon={step.icon} className="w-5 h-5" />
              {step.name}
            </motion.div>
            {i < steps.length - 1 && (
              <motion.div 
                initial={{ height: 0 }}
                whileInView={{ height: 30 }}
                viewport={{ once: true }}
                className="w-px bg-brand-teal/30 my-2 flex items-center justify-center"
              >
                <SafeIcon icon={FiIcons.FiArrowDown} className="text-brand-teal w-4 h-4 mt-8" />
              </motion.div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default FrameworkOS;